import { useDataModule } from '@perpay-web/data-module/useDataModule';
import { useReduxDataModuleHookConnection } from '@perpay-web/data-module/useReduxDataModuleHookConnection';
import {
    fetchIncompletePHOApplicationForDataModule,
    fetchIncompletePHOApplicationSuccess,
    fetchIncompletePHOApplicationError,
    fetchIncompletePHOApplicationReset,
} from '@perpay-web/fintech/actions/entities/incompletePHOApplication';
import { INCOMPLETE_PHO_APPLICATION_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { authenticatedJsonFetch } from '@perpay-web/fintech/utils/requestHandlers';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const useFetchIncompletePHOApplicationDataModule = () => {
    const dataModule = useDataModule(() =>
        authenticatedJsonFetch(INCOMPLETE_PHO_APPLICATION_ENDPOINT),
    );

    useReduxDataModuleHookConnection({
        dataModule,
        hookAction$,
        request: fetchIncompletePHOApplicationForDataModule,
        error: fetchIncompletePHOApplicationError,
        success: fetchIncompletePHOApplicationSuccess,
        reset: fetchIncompletePHOApplicationReset,
    });

    return dataModule;
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const dataModule = useFetchIncompletePHOApplicationDataModule();

        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [
    UseFetchIncompletePHOApplicationDataModuleProvider,
    useFetchIncompletePHOApplicationContext,
] = createContextProvider(providerFactory);
